<template>
  <div class="content-post-show">
    <van-nav-bar
    v-if="source==1&&pageLength>1"
    :title="info.title"
    :fixed="true"
    @click-left="onClickLeft">
    <template #left>
      <img class="back_icon" :src="img.back" />
    </template>
  </van-nav-bar>
  
  <van-nav-bar
  v-if="source==1&&pageLength==1"
  :title="info.title"
  :fixed="true"
  @click-left="onClickLeft">
  <template #left>
    <img class="home_icon" :src="img.home_icon" />
  </template>
</van-nav-bar>
<div class="show" :style="{'margin-top':source==1?'50px':'0'}" v-if="info">
  <div v-if="info.module.id==2">
    <div class="pic">
      <van-row gutter="5">
        <van-col span="16">
          <img @click="showImg(0)" v-if="info.pics && info.pics[0]" :src="info.pics[0].img_url" :alt="info.title" />
        </van-col>
        <van-col span="8">
          <img @click="showImg(1)" v-if="info.pics && info.pics[1]" :src="info.pics[1].img_url" :alt="info.title" class="right one" />
          <img @click="showImg(2)" v-if="info.pics && info.pics[2]" :src="info.pics[2].img_url" :alt="info.title" class="right" />
        </van-col>
      </van-row>
    </div>
  </div>
  <div v-if="info.module.id==3">
    <div class="video_box" v-if="info&&info.videoid">
      <iframe
      class="video_iframe"
      style="z-index:1;"
      :src="'https://v.qq.com/iframe/player.html?vid=' + info.videoid + '&amp;width=auto&amp;height=auto&amp;auto=0'"
      allowfullscreen=""
      frameborder="0"
      height="175"
      width="100%"
      >
    </iframe>
  </div>
  <div class="video_box_new" v-else-if="info&&info.videourl">
    <video x-webkit-airplay="" webkit-playsinline="" playsinline="" class="video" preload="meta" :poster="info.pic_url" :src="info.videourl" style="display: block;" controls></video>
  </div>
</div>


<h1>{{ info.title }}</h1>
<div class="media" v-if="info.media">
  <img
  :src="info.media.logo_url"
  />
  <span>{{ info.media.name }}</span>
  <span>{{ info.time_format }}</span>
</div>
<div v-html="content" class="content"></div>
</div>
<div class="recommend" v-if="recommends.length > 0">
  <h3>为您推荐</h3>
  <van-row gutter="15" v-for="re in recommends" :key="'recommend_' + re.id">
    <van-col span="8">
      <router-link :to="{name: 'ContentPostShow', params: {id: re.id}}">
        <img v-lazy="re.pic_url" :alt="re.title" />
      </router-link>
    </van-col>
    <van-col span="16">
      <router-link :to="{name: 'ContentPostShow', params: {id: re.id}}">
        <h2>{{ re.title }} <van-tag plain type="danger" v-if="re.label">{{ re.label.name }}</van-tag></h2>
      </router-link>
    </van-col>
  </van-row>
</div>
<div class="recommend">
  <h3 v-if="tripartite_info.length>0">当前文章第三方平台数据<span class="f-12 c-gray" style="font-weight: 400">（每24小时更新一次）</span></h3>
  <van-grid :border="false" :column-num="3">
    <van-grid-item v-for="item in tripartite_info" :key="'tripartite_info_' + item.title">
      <van-row>
        <van-col span="8">
          <img class="picthere" :src="item.logo">
        </van-col>
        <van-col span="15" offset="1">
          <div class="f-12">{{item.title}}</div>
          <div class="f-12 mt-5" v-if="item.read_num!=0">{{item.read_num}}人阅读</div>
          <div class="f-12 mt-5" v-if="item.read_num==0&&item.comment_num!=0">{{item.comment_num}}人评论</div>
        </van-col>
      </van-row>
    </van-grid-item>
  </van-grid>
  <van-row type="flex" justify="space-between" class="f-12 c-gray">
    <van-col span="22">
      {{info.read_text}}
    </van-col>
    <van-col span="2">
      <span @click="toTip">举报</span>
    </van-col>
  </van-row>
</div>
<div class="comments" v-if="info.replyshow==0">
  <h2>全部评论<span class="f-12 c-gray f-r" @click="sortlist()">{{params.order==1?'按时间':'按热度'}}</span></h2>
  <van-list
  v-model="loading"
  :finished="finished"
  finished-text="没有更多了"
  @load="onLoad"
  >
  <div slot="loading" class="list-loading">
    <img :src="img.loading" />
  </div>
  <div class="comment">
    <div v-for="(comment, index) in comments" :key="'commment_' + comment.id">
      <van-row class="btn-bor" gutter="15" v-if="source==1&&index<5">
        <van-col span="3" @click="goMy(comment.user.id)">
          <img class="avatar" :src="comment.user && comment.user.headimg_url&&comment.user.headimg_url.substring(0,5)=='https' ? comment.user.headimg_url : img.avatar" />
        </van-col>
        <van-col span="21">
          <h3>
            {{ comment.user.user_name }}
            <span class="binbox">
              <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.parise_have : img.show_parise">
              <span class="sourtime">{{ comment.praise_num }}</span>
            </span>
          </h3>
          <p v-if="comment.content" @click="goComment(comment.id,post_id)">{{ comment.content }}</p>
          <p class="time">{{ comment.create_time }}
            <span class="c-black" @click="replys(comment.id)"> · 回复
              <span v-if="comment.replys">({{ comment.replys.length }})</span>
            </span>
            <span v-if="comment.user.id==params.user_id" class="f-r" @click="delComment(comment.id,index)">删除</span>
            <span v-else class="f-r f-12" @click="toTip">举报</span>
          </p>
          <div class="replys" v-if="comment.replys" @click="goComment(comment.id,post_id)">
            <van-row v-for="(reply,index) in comment.replys" :key="'replys_' + reply.id" v-show="index>2?false:true">
              <van-col span="3">
                <img class="headimg" :src="reply.user.headimg_url&&reply.user.headimg_url.substring(0,5)=='https' ? reply.user.headimg_url : img.avatar" >
              </van-col>
              <van-col span="21">
                <span class="f-w" v-if="reply.user">{{ reply.user.user_name }}</span>
                <span class="pd-5" v-if="reply.reuser">回复</span>
                <span class="f-w">{{ reply.reuser.user_name }} :</span>
                {{ reply.content }}
              </van-col>
            </van-row>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</van-list>
<div class="text-c pd-30" @click="showQrcode" v-if="source==1&&comments.length>4">
  <div class="more_comm" :style="'background-image:url('+img.more_comm+')'">
    查看更多请访问小程序
  </div> 
</div>
</div>
<div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
<div class="postbottom" id="inputid" v-if="nobrowser">
  <van-row>
    <van-col :span="inputnum">
      <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
    </van-col>
    <van-col  v-if="inputshow" class="botright" span="10">
      <van-row>
        <van-col span="8"> 
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="num" v-if="info.reply_num>0">{{info.reply_num}}</span>
          </span>
        </van-col>
        <van-col span="10">
          <span class="binbox" @click="Collect(info.is_collect)">
            <img class="binpic" :src="info.is_collect==1?img.collect_have:img.collect">
            <span class="num" v-if="info.collect>0">{{info.collect}}</span>
          </span>
        </van-col>
        <van-col span="6">
          <span class="binbox" @click="outrelay(info.title,info.subtitle,'/lexus/article/'+info.id+'/post',info.pic_url)">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
      </van-row>
    </van-col>
    <van-col v-else span="5">
      <van-button color="#F6AB00" size="small" @click="post()">发表</van-button>
    </van-col>
  </van-row>
</div>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="2">
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
  </van-grid>
</van-action-sheet>
<van-image-preview
v-model="showState"
:images="images"
lazyLoad
@change="changeImg"
>
<template v-slot:index>
  {{ imgIndex + 1 }}/{{ images.length }}
  <h5>{{ titles[imgIndex] }}</h5>
</template>
</van-image-preview>
<div class="wask_page" v-if="qrcode" @click="hideQrcode"></div>
<div class="wask_qrcode" :style="'background-image:url('+img.qrcode_bg+')'" v-if="qrcode">
  <img class="wechatqr" :src="img.wechateq">
  <div class="nocopy" style="margin-top: 30px;">微信扫码</div>
  <div class="nocopy">关注“{{wechat_name}}”小程序</div>
</div>
</div>
</template>
<script>
  import content from '../../../api/content';
  import wxShare from '../../../api/wxShare';
  import member from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import {Row, Col, Tag,NavBar,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Lazyload } from "vant";
  export default {
    data () {
      return {
        showState: false,
        images: [],
        titles: [],
        imgIndex: 0,
        value:'',
        inputshow:true,
        post_id:'',
        overlay:false,
        inputfocus:false,
        inputnum:14,
        rid:'',
        info: '',
        recommends: [],
        tripartite_info:[],
        params: {
          page: 1,
          size: 10,
          order: 1,
          user_id: 0
        },
        loading: false,
        finished: false,
        comments: [],
        shareshow:false,
        nobrowser:true,
        qrcode:false,
        wechat_name:'汽车时间Motortime',
        content:'',
        pageLength:1,
        isScroll:true,
        img: {
          avatar: require('../../../assets/img/lexus/default.png'),
          show_parise: require('../../../assets/img/show_parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          show_no_parise: require('../../../assets/img/show_no_parise.png'),
          no_parise_have: require('../../../assets/img/no_parise_have.png'),
          motortimelogo:require('../../../assets/img/motortimelogo.png'),
          subaru:require('../../../assets/img/subaru.png'),
          honda:require('../../../assets/img/vtec.png'),
          lexus:require('../../../assets/img/lexus.png'),
          porsche:require('../../../assets/img/porsche.png'),
          volvo:require('../../../assets/img/volvo.png'),
          collect: require('../../../assets/img/collect.png'),
          collect_have: require('../../../assets/img/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          friends: require('../../../assets/img/friend.png'),
          wechat: require('../../../assets/img/wecheck.png'),
          wechateq: require('../../../assets/img/wechateq.png'),
          more_comm: require('../../../assets/img/more_comm.png'),
          qrcode_bg: require('../../../assets/img/qrcode_bg.png'),
          home_icon: require('../../../assets/img/home_icon.png'),
          back: require('../../../assets/img/back.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    watch: {
      '$route'() {
        if(this.$route.params.id != this.post_id) {
          this.post_id = this.$route.params.id
          this.getInfo()
          this.getRecommends()
        }
      }
    },
    created () {
      this.pageLength=window.history.length
      if(this.$route.query.code){
        if(this.source == 1){
          if(!localStorage.getItem('token')){
            this.getAuthorization.getAuthorization();
          }
        }
      }
      this.weburl=process.env.VUE_APP_URL
      if(this.source == 3||this.source == 7) {
        this.$appService.isShowReturn({state: true})
      }
      this.$store.commit('param/show', false)
      let id = this.$route.params.id
      if(this.$util.isEmpty(id)) {
        this.$toast('内容不存在')
        return false
      }
      if(localStorage.getItem('browser')){
        this.nobrowser=false
      }else{
        this.nobrowser=true
      }
      this.post_id = id
      this.getInfo()
      this.getRecommends()
    },
    mounted(){
      window.addEventListener("scroll", (e) => {
        if(this.isScroll){
          this.isScroll=false
          this.getRecommends()
        }
      // 这里做一个 节流 操作
      if (this.timer) return;
      this.timer = setTimeout(() => {
        this.query("img[data-src]").forEach((img) => {
          const rect = img.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            img.src = img.dataset.src;
            // 我们是通过img[data-src]查找所有img标签的，渲染后就删除data-src可减少forEach循环的计算成本
            img.removeAttribute("data-src"); 
          }
        });
        this.query("video[data-src]").forEach((video) => {
          const rect = video.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            video.src = video.dataset.src;
            // 我们是通过img[data-src]查找所有img标签的，渲染后就删除data-src可减少forEach循环的计算成本
            video.removeAttribute("data-src"); 
          }
        });
        clearTimeout(this.timer);
        // 这里一定要把定时器置为 null
        this.timer = null
      }, 300);
    });
    },
    methods: {
      query(selector) {
        return Array.from(document.querySelectorAll(selector));
      },
      setPraise () {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
              let type = this.info.is_praise ? 2 : 1;
              content.setPraise({id: this.info.id, type: type}).then(res => {
                if(res.data.state == 1) {
                  if(type == 1) {
                    this.info.is_praise = 1
                    this.info.praise += 1
              // this.$toast.success('点赞成功')

              //取消一般般
              if(this.info.is_praise_no) {
                content.setNoPraise({id: this.info.id, type: 2}).then(res => {
                  this.info.is_praise_no = 0
                })
              }
            } else {
              this.info.is_praise = 0
              this.info.praise -= 1
              // this.$toast.success('取消成功')
            }
          }
        })
            } else {
              var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
            let type = this.info.is_praise ? 2 : 1;
            content.setPraise({id: this.info.id, type: type}).then(res => {
              if(res.data.state == 1) {
                if(type == 1) {
                  this.info.is_praise = 1
                  this.info.praise += 1
              // this.$toast.success('点赞成功')

              //取消一般般
              if(this.info.is_praise_no) {
                content.setNoPraise({id: this.info.id, type: 2}).then(res => {
                  this.info.is_praise_no = 0
                })
              }
            } else {
              this.info.is_praise = 0
              this.info.praise -= 1
              // this.$toast.success('取消成功')
            }
          }
        })
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
      },
      setNoPraise () {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
              let type = this.info.is_praise_no ? 2 : 1;
              content.setNoPraise({id: this.info.id, type: type}).then(res => {
                if(res.data.state == 1) {
                  if(type == 1) {
                    this.info.is_praise_no = 1
              // this.$toast.success('成功')

              //取消点赞
              if(this.info.is_praise) {
                content.setPraise({id: this.info.id, type: 2}).then(res => {
                  this.info.is_praise = 0
                  this.info.praise -= 1
                })
              }
            } else {
              this.info.is_praise_no = 0
              // this.$toast.success('取消成功')
            }
          }
        })
            } else {
              var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
            let type = this.info.is_praise_no ? 2 : 1;
            content.setNoPraise({id: this.info.id, type: type}).then(res => {
              if(res.data.state == 1) {
                if(type == 1) {
                  this.info.is_praise_no = 1
              // this.$toast.success('成功')

              //取消点赞
              if(this.info.is_praise) {
                content.setPraise({id: this.info.id, type: 2}).then(res => {
                  this.info.is_praise = 0
                  this.info.praise -= 1
                })
              }
            } else {
              this.info.is_praise_no = 0
              // this.$toast.success('取消成功')
            }
          }
        })
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
      },
      getInfo () {
        let user_id = this.user ? this.user.id : 0
        content.getShow(this.post_id, {user_id: user_id,source:1}).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            // this.content=this.info.content.replace(/(<br\s?\/?>)+/g, '')
            // var str=this.info.content.replace(/(<br\s?\/?>)+/g, '')
            let regex = /<p>[\s\n\t&nbsp;]*<\/p>/g;
            this.content= this.info.content.replace(regex, "<p></p>");  
            this.tripartite_info=res.data.data.tripartite_info
            this.$util.title(res.data.data.title)
            var apppar={
              title:res.data.data.title
            }
            this.$appService.changeTitle(apppar)
            this.images = []
            this.titles = []
            for(let i of res.data.data.all_pics) {
              this.images.push(i.img_url)
              this.titles.push(i.title)
            }
            // var media_name=res.data.data.media.name?'-'+res.data.data.media.name:''
            if(res.data.data.title){
              document.title = res.data.data.title+'-汽车时间';
            }
            if(res.data.data.keywords){
              document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keywords)
            }
            if(res.data.data.description){
              document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.description)
            }
            if(res.data.data.qrcode){
             this.img.wechateq=res.data.data.qrcode.image
             this.wechat_name=res.data.data.qrcode.name
           }
           var dataForWeixin=res.data.data
           content.getShare({url:encodeURI(location.href)}).then(res => {
            if(res.data.state == 1) {
             wxShare.getJSSDK(res.data.data, dataForWeixin)
           }
         })
         }
       })
      },
      onClickLeft(){
        if(this.pageLength==1){
          this.$router.push({name:'Home'});
        }else{
          this.$router.go(-1)
        }
      },
      getRecommends () {
        content.getRecommends(this.post_id, {}).then(res => {
          if(res.data.state == 1) {
            this.recommends = res.data.data
          }
        })
      },
  // =============
  sortlist(){
    this.params.order=this.params.order==1?2:1
    this.params.page=1
    this.comments=[]
    this.getCommentList()
  },
  setCommentPraise(index){
    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
          let type = this.comments[index].is_praise ? 2 : 1;
          content.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.comments[index].is_praise = 1
                this.comments[index].praise_num += 1
              } else {
                this.comments[index].is_praise = 0
                this.comments[index].praise_num -= 1
              }
            }
          })
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
    }else if(this.source == 1){
      if(localStorage.getItem('token')){
        this.token=true
        let type = this.comments[index].is_praise ? 2 : 1;
        content.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.comments[index].is_praise = 1
              this.comments[index].praise_num += 1
            } else {
              this.comments[index].is_praise = 0
              this.comments[index].praise_num -= 1
            }
          }
        })
      }else{
        this.getAuthorization.getAuthorization();
      }
    }
  },
  toTip() {
    this.$toast.success('举报成功')
  },
  inputFocus(){//点击输入框聚焦
    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
    }else if(this.source == 1){

      if(localStorage.getItem('token')){
        this.token=true
        member.getMemberInfo({source:this.source}).then(res => {
          if(res.data.state == 1) {
            this.params.user_id=res.data.data.id
            var binding_status=res.data.data.phone_binding_status.status
            var mobile=res.data.data.mobile
            if(mobile){
              this.inputshow=false;
              this.overlay=true;
              this.inputnum=19;
              setTimeout(() => {
                var cc=document.getElementById('inputid');
                cc.scrollIntoViewIfNeeded(true);
              },500);
            }else{
              this.$refs.inputTag.blur()
              this.$dialog.confirm({
                title:'温馨提示',
                message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                width:'80%',
                messageAlign:'left',
                confirmButtonText:'去绑定',
              }).then(() => {
                this.$router.push({name:'BoundMobile',params:{source:this.source}});
              }).catch(() => {
                this.inputshow=false;
                this.overlay=true;
                this.inputnum=19;
                setTimeout(() => {
                  var cc=document.getElementById('inputid');
                  cc.scrollIntoViewIfNeeded(true);
                },500);
              });
              
            }

          }
        })
      }else{
        this.getAuthorization.getAuthorization();
      }
    }

  },
      replys(rid){//点击回复聚焦
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
              var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
            member.getMemberInfo({source:this.source}).then(res => {
              if(res.data.state == 1) {
                this.params.user_id=res.data.data.id
                var binding_status=res.data.data.phone_binding_status.status
                var mobile=res.data.data.mobile
                if(mobile){
                  this.inputshow=false;
                  this.overlay=true;
                  this.inputnum=19;
                  this.inputfocus=true
                  this.$refs.inputTag.focus()
                  this.rid=rid
                  setTimeout(() => {
                    var cc=document.getElementById('inputid');
                    cc.scrollIntoViewIfNeeded(true);
                  },500);
                }else{
                  this.$refs.inputTag.blur()
                  this.$dialog.confirm({
                    title:'温馨提示',
                    message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                    width:'80%',
                    messageAlign:'left',
                    confirmButtonText:'去绑定',
                  }).then(() => {
                    this.$router.push({name:'BoundMobile',params:{source:this.source}});
                  }).catch(() => {
                    this.inputshow=false;
                    this.overlay=true;
                    this.inputnum=19;
                    this.inputfocus=true
                    this.$refs.inputTag.focus()
                    this.rid=rid
                    setTimeout(() => {
                      var cc=document.getElementById('inputid');
                      cc.scrollIntoViewIfNeeded(true);
                    },500);
                  });
                  
                }

              }
            })
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      post(){
        let params={
          rid:this.rid,
          archive_id:this.post_id,
          content:this.value
        }
        content.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.params.page = 1
          this.getCommentList()
        }
      })
      },
      getCommentList(){
        this.params.source=this.source
        content.getCommentList(this.post_id, this.params).then(res => {
          this.comments.push.apply(this.comments, res.data.data.data)
          this.params.page += 1
          if(this.source!=1){
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          }
          
        })
      },
      Collect(type){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
              var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        var param={
          id:this.info.id,
          type: type==1?2:1
        }
        content.Collect(param).then(res => {
          if(res.data.state == 1) {
            if(param.type == 1) {
              this.info.is_collect = 1
              this.info.collect += 1
            } else {
              this.info.is_collect = 0
              this.info.collect -= 1
            }
          }
        })
      },
      delComment(id,index){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
              var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
         content.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            this.comments.splice(index,1);
          }
        })
       }).catch(() => {});
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,url,imageUrl){
        if(this.source==3){
          this.shareshow=true
          this.sharetitle=title
          this.sharecontent=content
          this.shareurl=this.weburl+url
          if(imageUrl){
            this.shareimageUrl=imageUrl
          }else{
            this.shareimageUrl='https://pic.motortime.com/logo/motortime_logo.png'
          }
        }else{
          this.$toast.success('请点击右上角选项分享')
        }
      },
      toShare(type){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      },
      showQrcode(){
        this.qrcode=true
      },
      hideQrcode(){
       this.qrcode=false
     },
     showImg(key) {
      this.imgIndex = key
      this.showState = true
    },
    changeImg (index) {
      this.imgIndex = index
    },
    onLoad() {
      this.params.user_id = this.user ? this.user.id : 0
      setTimeout(() => {
        this.getCommentList()
      }, 500);
    },
  },

  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [NavBar.name]:NavBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]:List,
    [Field.name]:Field,
    [Button.name]:Button,
    [Overlay.name]:Overlay,
    [ActionSheet.name]:ActionSheet,
    [Divider.name]:Divider,
    [Lazyload.name]:Lazyload,
  }
};
</script>

<style lang="scss">
  .content-post-show {

    h1{
      color: #3a3a3a;
      font-size: 20px;
    }
    margin-bottom: 50px;
    background-color: #F0F0F0;
    // .van-nav-bar__left {
      //   left: 5px;
      // }
      .pic {

        img {
          width: 100%;
          height: 205px;
          object-fit: cover;
          display: block;

          &.right {
            height: 100px;
          }
          &.one {
            margin-bottom: 5px;
          }
        }
      }
      .show {
        padding: 10px;
        background-color: #FFF;
        font-size: 14px;
        color: #3A3A3A;

        h3 {
          font-size: 17px;
          margin: 0;
        }
        .media {
          color: #9A9A9A;
          font-size: 12px;
          margin: 20px 0;

          img {
            width: 30px;
            border-radius: 15px;
            vertical-align: middle;
          }
          span {
            margin-left: 10px;
          }
        }
        .content {
          font-size: 14px !important;
          line-height: 2;

          img {
            max-width: 100%;
          }
          iframe{
            max-width: 100%;
          }
          video{
            max-width: 100%;
          }
          br {
            line-height: 1;
          }
        }
        
        .video_box{
          max-width: 100%;
          height: 200px;
        }
        .video_box_new{
          max-width: 100%;
          min-height: 200px;
        }
        .video{
         min-height: 200px;
         width:100%;
         z-index:1;
         object-fit: cover;
       }
       .content iframe{
        width: 100%;
        height: 200px;
      }
      .content video{
        width: 100%;
        height: 200px;
      }
      .parise {
        text-align: center;
        margin: 30px 0 50px 0;

        a {
          color: #3A3A3A;
          font-size: 11px;
          display: inline-block;
          width: 110px;
          height: 35px;
          border: 1px solid #9A9A9A;
          line-height: 35px;
          border-radius: 17px;
          margin: 0 7px;
          box-sizing: border-box;

          img {
            width: 15px;
            height: 14px;
            vertical-align: middle;
            margin-right: 7px;
          }
        }
      }
    }
    .recommend {
      padding: 10px;
      border-top: 1px solid #EAEAEA;
      background-color: #fff;
      h3 {
        font-size: 13px;
      }
      img {
        width: 100%;
        height: 100px;
        border-radius: 3px;
        display: block;
        object-fit: cover;
      }
      h2 {
        font-size: 16px;
        margin: 0;
        color: #3A3A3A;

        .van-tag {
          font-weight: normal;
        }
      }
      .van-row {
        margin-bottom: 10px;
      }
      .picthere{
        width: 100%;
        height: auto;
      }
      .van-grid-item__content{
        padding: 10px 0;
      }
    }
    .comments {
      background-color: #FFF;
      margin-top: 10px;

      h2 {
        font-size: 13px;
        font-weight: normal;
        padding: 15px 10px;
        border-bottom: 1px solid #EAEAEA;
        margin: 0;
      }
      .comment {
        margin: 0 10px;
        overflow: hidden;
        .van-row {
          padding: 5px 0;
        }
        .btn-bor{
          padding: 10px 0;
          border-bottom: 1px solid #EAEAEA;
        }
        .avatar {
          width: 30px;
          height: 30px;
          object-fit: cover;
          border-radius: 15px;
        }
        h3 {
          font-size: 15px;
          margin: 8px 0;

          .binbox {
            color: #9A9A9A;
            font-size: 12px;
            float: right;
            font-weight: normal;

            img {
              width: 15px;
              height: 14px;
              margin-right: 11px;
              vertical-align: middle;
            }
            .sourtime{
              vertical-align: middle;
            }
          }
        }
        p {
          font-size: 15px;

          .c-blue {
            font-style: normal;
          }
          &.time {
            font-size: 12px;
            color: #9A9A9A;

            span {
              margin-left: 5px;
            }
          }
        }
        img {
          width: 30px;
          height: 30px;
          border-radius: 15px;
        }
        .replys {
          .van-row {
            font-size: 13px;
          }
          .pd-5{
            padding: 0 5px;
          }

        }
      }
    }
  }
</style>
